import AccountFactPreferences from '../../sections/@dashboard/user/account/AccountFactPreferences';

export default function AccountTabsFactPreferencesPage() {
  return <AccountFactPreferences />;
}
